export default __webpack_public_path__ + "img/sante-homepage.d8f2d160.svg";